import './SingleSlide.css';


const SingleSlide = ({item}) => (
    <div>
        <img
            src={item.imgSrc}
            alt="Certificate"
            className='certificate__image'
        />
        {item.certificateLink &&
        <a
        href={item.certificateLink}
        target="_blank"
        >
        <span type="button" className="btns onbt view">
            Verify
        </span>
        </a>}
    </div>
  )


export default SingleSlide;